import { useEffect, useMemo, useState } from 'react';
import { z } from 'zod';
var makeValidOnlySchema = function (s) {
    return z.array(z.any()).transform(function (as) { return as.filter(function (a) { return s.safeParse(a).success; }); });
};
var makeInValidOnlySchema = function (s) {
    return z.array(z.any()).transform(function (as) { return as.filter(function (a) { return !s.safeParse(a).success; }); });
};
export function useValidate(data, schema, onValidate) {
    if (onValidate === void 0) { onValidate = function () { }; }
    var _a = useState([]), validItems = _a[0], setValidItems = _a[1];
    var _b = useState([]), invalidItems = _b[0], setInvalidItems = _b[1];
    var validOnlyItemsSchema = useMemo(function () { return makeValidOnlySchema(schema); }, [schema]);
    var invalidOnlyItemsSchema = useMemo(function () { return makeInValidOnlySchema(schema); }, [schema]);
    useEffect(function () {
        if (!data || data.length < 1)
            return;
        var result = z.array(schema).safeParse(data);
        if (!result.success) {
            var valid = validOnlyItemsSchema.parse(data);
            var invalid = invalidOnlyItemsSchema.parse(data);
            setValidItems(valid);
            setInvalidItems(invalid);
            onValidate(result.error.issues);
            return;
        }
        setValidItems(result.data);
    }, [data]);
    return useMemo(function () { return ({ valid: validItems, invalid: invalidItems }); }, [validItems, invalidItems]);
}
